import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DragulaExtendedDirective } from "./directives/dragula-extended.directive";
import { LinkListingComponent } from "./components/link-listing/link-listing.component";
import { DragulaModule, DragulaService } from "ng2-dragula";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { FormsModule } from "@angular/forms";
import { TrustPipe } from "./pipes/trust.pipe";

@NgModule({
  imports: [
    CommonModule,
    NgxDatatableModule,
    /* Ng2SmartTableModule,
    NgbModule, */
    FormsModule,
    DragulaModule
  ],
  declarations: [LinkListingComponent, TrustPipe, DragulaExtendedDirective],
  exports: [LinkListingComponent, TrustPipe, DragulaExtendedDirective],
  providers: [DragulaService]
})
export class SharedModule {}
